<template>
  <div v-if="descTemplate" class="ins-result-wrap">
    <LiabilityDetail
      ref="liability"
      :temp="descTemplate"
      :data="descData"
      :show-type="0"
      :miniprogram="miniprogram"
      :product-name-list="productNameList"
      @disShow="fetchDisData"
    />
  </div>
</template>
  
<script>
import LiabilityDetail from './detail.vue'
export default {
  // 该 name 不能删除，./detail.vue 中 dispatch 向上查询组件需要用到，否则，无法触发某个方法
  name: 'InsResultV2',
  components: {
    LiabilityDetail
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
    productNameList: {
      type: Object,
      default: null,
    },
    miniprogram: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      descTemplate: '',
      descData: '',
      disData: [],
      disActive: 0,
      disVisible: false,
      disHeader: '病种详情',
      disLink: '',
    }
  },
  watch: {
    template(newTemplate) {
      this.pageInit(newTemplate)
    },
  },
  created() {
    this.pageInit()
  },
  methods: {
    // 初始化
    pageInit(temp = this.template) {
      if (temp) {
        this.descTemplate = {
          liabilities: temp.liabilities,
          name: temp.card.name,
          insuranceTypeId: temp.resultData.insuranceTypeId,
          trades: temp.trades,
          accountMap: temp.accountMap,
          insuredAge: temp.insuredAge,
          categorySort: temp.resultData.categorySort,
          categorySortList: temp.categorySortList,
          descShow: temp.descShow,
        }
        this.descData = this.template.calData
      }
    },
    fetchDisData(path) {
      let { pidx, idx } = path

      let liabilities =
        this.descTemplate.liabilities[pidx].insuranceLiabilities[idx]
          .liabilities

      let diseaseAry = []
      liabilities.forEach((liab) => {
        const { title, link, detail } = liab.disease
        title &&
          diseaseAry.push({
            title,
            link,
            detail,
          })
      })
      this.disData = this._normalizeDisText(diseaseAry)
      // this.disHeader = header
      // this.disLink = link
      this.disVisible = true
    },
    _closeDisDialog() {
      this.disVisible = false
    },
    _normalizeDisText(list) {
      let ret = []
      list.forEach((dis, index) => {
        // let text = dis.text
        let { title, link, detail } = dis

        detail = `${detail.replace(
          /\d+[\、|\.]/g,
          '</p><p><span>$&</span>'
        )}</p>`
        detail = detail.replace(/<\/p>/, '')
        ret.push({
          title,
          link,
          detail,
        })
      })
      return ret
    },
  },
}
</script>
  